import React, { useEffect, useState } from 'react';
import { Button, Spin, Table } from 'antd';
import moment from 'moment';
import { ColumnsType } from 'antd/es/table';
import NoCouponData from '@/pages/guest/component/NoCouponData';
import { fetchRevertXuanzhuCoupon, fetchUseXuanzhuCoupon } from '@/api/guest';
import { DATE_TIME_FORMAT } from '@/config';
import { renderIntlLabel } from '@/utils';
import { getTimeByUtcOffset } from '@/utils/intl';

const XuanzhuCouponList: React.FC<any> = ({
  wyuid,
  remark,
  xuanzhuCouponList,
  xuanzhuCouponListLoading,
  getOptionalManualCouponListFn,
  onUpdateCoupon,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleBtnClick = async (record, index) => {
    const { status, id } = record || {};
    if (status === 1) {
      // 已使用，撤回
      setLoading(true);
      try {
        const res = await fetchRevertXuanzhuCoupon({ couponId: id, remark });
        if (res?.code === 0) {
          if (typeof onUpdateCoupon === 'function') {
            onUpdateCoupon(index, { status: 0 });
          }
        }
      } catch (error) {
        //
      } finally {
        setLoading(false);
      }
    } else {
      // 使用
      setLoading(true);
      try {
        const res = await fetchUseXuanzhuCoupon({ couponId: id, remark });
        if (res?.code === 0) {
          if (typeof onUpdateCoupon === 'function') {
            onUpdateCoupon(index, { status: 1 });
          }
        }
      } catch (error) {
        //
      } finally {
        setLoading(false);
      }
    }
  };

  const columns: ColumnsType<any> = [
    { title: renderIntlLabel('guest_coupon_label_card_coupon_name'), dataIndex: 'couponName' },
    { title: renderIntlLabel('guest_coupon_label_send_remark'), dataIndex: 'remark' },
    { title: renderIntlLabel('guest_coupon_label_source'), dataIndex: 'source' },
    {
      title: renderIntlLabel('guest_coupon_label_send_Time'),
      dataIndex: 'startTime',
      render: (val) => (val ? getTimeByUtcOffset(val, DATE_TIME_FORMAT) : ''),
    },
    {
      title: renderIntlLabel('guest_coupon_label_use_status'),
      dataIndex: 'status',
      render: (val) =>
        val === 1
          ? renderIntlLabel('guest_coupon_tab_have_been_used')
          : renderIntlLabel('guest_coupon_tab_have_been_unused'),
    },
    {
      title: renderIntlLabel('guest_action_use'),
      render: (_, record, index) => (
        <Button type="link" onClick={() => handleBtnClick(record, index)}>
          {record?.status === 1
            ? renderIntlLabel('guest_action_widthdraw')
            : renderIntlLabel('guest_action_use')}
        </Button>
      ),
      align: 'right',
      fixed: 'right',
    },
  ];

  useEffect(() => {
    if (wyuid && getOptionalManualCouponListFn) {
      getOptionalManualCouponListFn({ wyuid });
    }
  }, [wyuid, getOptionalManualCouponListFn]);

  return (
    <>
      {Array.isArray(xuanzhuCouponList) && xuanzhuCouponList.length ? (
        <>
          <div>{renderIntlLabel('guest_coupon_label_cannot_withdraw_once_use')}</div>
          <div>{renderIntlLabel('guest_coupon_label_calc_sale_money_manually')}</div>
        </>
      ) : null}

      <Spin spinning={loading || xuanzhuCouponListLoading}>
        {Array.isArray(xuanzhuCouponList) && xuanzhuCouponList.length ? (
          <Table
            rowKey="id"
            columns={columns}
            dataSource={xuanzhuCouponList}
            pagination={false}
            scroll={{ x: 'max-content' }}
            style={{ marginTop: '16px' }}
          />
        ) : (
          <NoCouponData />
        )}
      </Spin>
    </>
  );
};

export default XuanzhuCouponList;
